export const EMPLOYEE_ACTIONS = {
  ADD_EMPLOYEE: "add-employee",
  DELETE_EMPLOYEE: "delete-employee",
  EDIT_EMPLOYEE: "edit-employee",
  RESET_EMPLOYEE_PASSWORD: "reset-employee-password",
};

export const DEALER_ACTIONS = {
  SET_DEALER_DEFAULT_PURCHASE_PARTNER: "set-dealer-default-purchase-partner",
  REFRESH_DEALER_DETAILS: "refresh-dealer-details",
  EDIT_DEALER: "edit-dealer",
};
